/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
 
import React, { useContext, useEffect } from 'react'
import { FormContext } from '../Component/Forms/FormContext';
import OutlinedInput from '@mui/material/OutlinedInput';
import {InputLabel} from '@material-ui/core';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import elementValidate from '../Component/validation';
import ThemeControls from "../Component/AllThemesControl";
import { APIGET } from '../services/APIServices';
import { MasterContext } from '../services/MasterContext'; 
import { debounce } from 'lodash';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import moment from 'moment';



export default function DatePicker(props) {
  const {useStyle} = ThemeControls;
  const classes = useStyle();
  let {masterData} = React.useContext(MasterContext);
  const {id,field_type, field_id, field_label,field_temp_value,field_option_src, field_pastDisable,field_placeholder,field_disabled, field_value, field_options,field_helperText,field_minlength,field_maxlength,field_maxvalue,field_value_type,field_minvalue,field_error_msg_required,field_error_msg_minlength,field_error_msg_maxlength,field_error_msg_minvalue,field_error_msg_maxvalue,field_error_msg_uq,onChange,field_mandatory } = props;
  const { handleChange } = useContext(FormContext)
  const [fieldOptions,setFieldOptions] = React.useState(field_options);
  const [minDate, setMinDate] = React.useState('');
  // const formatAs = (date) => {
  //   if (!date) return '';
  //   const [day, month, year] = date.split('-');
  //   return `${year}-${month}-${day}`;
  // };

  const formatAs = (date) => {
    if (!date || typeof date !== 'string') return '';
    const [day, month, year] = date.split('-');
    return `${year}-${month}-${day}`;
};


// console.log(field_value)
  const [value, setValue] = React.useState(formatAs(field_value));

  const field = {
    field_id:field_id,
    field_type:field_type,
    field_value:field_value,
    field_helperText:field_helperText,
    field_minlength:field_minlength,
    field_maxlength:field_maxlength,
    field_minvalue:field_minvalue,
    field_maxvalue:field_maxvalue,
    field_value_type:field_value_type,
    field_mandatory:field_mandatory,
    field_label:field_label,
    field_error_msg_minvalue:field_error_msg_minvalue
  }
    function handleBlur(){
      elementValidate(field)
    }

    const debouncedGetOptions = debounce(getOptions, 300);
    async function getOptions(props) {
      try{
        if(props.field_option_src_context){
           
      
                let APIRES = await APIGET(props.field_option_src_context+`/`+props.field_option_src_critieria).then(
                (APIRES)=>{
                    // console.log(APIRES);
                    let responseArray =new Array();
                    function addDays(dateStr, days) {
                      // Split the date string (expected in dd-mm-yyyy format)
                      const [day, month, year] = dateStr.split('-').map(Number);
                      
                      // Create a new Date object from the parsed values
                      const date = new Date(year, month - 1, day); // Month is zero-indexed in JavaScript
                    
                      // Add the days
                      date.setDate(date.getDate() + days);
                    
                      return date;
                    }
                if(APIRES.data){
                 let days = APIRES.data[0][props?.field_option_value]
                //  console.log(days)
                 if(days){
                  var currentDate = new Date(); // Get current date
                  var newDate = addDays(props.field_select_all_value, days+1);
                  // alert(newDate)
                  setValue(formatDate(newDate));
                  handleChange(field_id, formatAsDate(formatDate(newDate)), formatAsDate(formatDate(newDate)));
                 }
                }
                }
                );            
                               
        }
      } catch(err){/** TODO Do Nothing */}
    }
    useEffect(()=>{
      if(props?.field_option_src?.field_option_src_critieria&&!id){
        debouncedGetOptions(field_option_src);
      }
    },[field_option_src])
   
  const handleDateChange = (event) => {
    let value=event.target.value
    // console.log(value)
    setValue(value);
    handleChange(field_id, formatAsDate(value), formatAsDate(value));
  };

  useEffect(()=>{
    if(field_value===""){
      setValue('')
    }
    },[field_value]);


  const formatAsDate = (date) => {
    if (!date) return '';
    const [year, month, day] = date.split('-');
    return `${day}-${month}-${year}`;
  };

  function formatDate(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
  
    return `${year}-${month}-${day}`;
  }

    useEffect(()=>{
    if(field_temp_value){
      setValue(formatAs(field_temp_value))
      handleChange(field_id, field_temp_value, field_temp_value);
    }
    },[field_temp_value]);

    useEffect(()=>{
    if(field_minvalue){
      if(field_minvalue==='past'){
        const currentDate = new Date();
        // Get local time zone offset in minutes
        const offsetMinutes = currentDate.getTimezoneOffset(); 
        // Adjust current date by subtracting the offset in minutes
        const todayDate = new Date(currentDate.getTime() - offsetMinutes * 60000).toISOString().split('T')[0];
        setMinDate(todayDate)
      }else{
        setMinDate(field_minvalue)
      }
    }
    },[field_minvalue]);

  
    useEffect(() => {
      if(field_value===""){
        if (field_value_type === "today") {
          const today = new Date();
          setValue(formatDate(today));
          handleChange(field_id, formatAsDate(formatDate(today)), formatAsDate(formatDate(today)));
      } else if (field_value_type === "yesterday") {
          const yesterday = new Date();
          yesterday.setDate(yesterday.getDate() - 1);
          setValue(formatDate(yesterday));
          handleChange(field_id, formatAsDate(formatDate(yesterday)), formatAsDate(formatDate(yesterday)));
      } else if (field_value_type === "tomorrow") {
          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);
          setValue(formatDate(tomorrow));
          handleChange(field_id, formatAsDate(formatDate(tomorrow)), formatAsDate(formatDate(tomorrow)));
      }
      }
  }, [field_value_type]);
  

  return (

    <div className={classes.inputroot}>
     <div style={{display:"flex"}}>
    <InputLabel className={classes.label}>{field_label}</InputLabel>{field_mandatory==="yes"?<span 
    style={{fontSize: "18px",
    color: "#d71729",
    fontWeight: "400",
    lineHeight: "20px",
    transform: "translateY(-2px)"}}>*</span>:null}
    </div>
     {/* <LocalizationProvider dateAdapter={AdapterDayjs} >
        <DesktopDatePicker className={classes.input}
          inputFormat="DD/MM/YYYY"
          // value={value}
          // value='02/Jan/2024'
           onChange={(date) => {
            handleChangeDate(date)
          }}
          disabled={field_disabled}
          minDate={past}
          disablePast={field_pastDisable}
          renderInput={(params) => <TextField id={field_id} {...params} onBlur={handleBlur}/>}
        />
    </LocalizationProvider> */}
    <OutlinedInput className={classes.input}
    // <input className={classes.input}
    type='date'
    id={field_id}
    value={value}
    // value={value}
    onBlur={handleBlur}
    disabled={field_disabled}
    onChange={handleDateChange}
    placeholder="DD-MM-YYYY"
    inputProps={{ min: minDate }}
    />
      <FormHelperText>{field_helperText}</FormHelperText>
    </div>
  );
}
